import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import contextReducer from './contextSlice';
import uiReducer from './uiSlice';
import operationBlockReducer from './operationBlockSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    context: contextReducer,
    ui: uiReducer,
    operationBlock: operationBlockReducer,
  },
});

export default store;
